const transactionQueryBuilder = require('./transaction-query-builder.js')

const transactions = `
transactions AS (
  ${transactionQueryBuilder({includeInvoicePayment: true})}
)
`

module.exports = transactions
